import axios from "axios";
import qs from "qs";
import config from "./config";
//import FormData from 'form-data';

let domain;
if (process.env.NODE_ENV === 'development') {
  domain = config.devHost;
} else {
  domain = config.prodHost;
}

export const baseURL = domain + config.prefix;
const ax = axios.create({baseURL});

/* АВТОРИЗАЦИЯ */
// Первая ступень авторизации
// Авторизация по логину и паролю
// (получение временного токена и высылка кода на телефон)
export const signInByLP = async (login, password) => {
  const response = ax.post('/auth', {
    login,
    password,
  });
  return response;
};

// Вторая ступень авторизации
// Высылает код, который пришел на телефон
// В заголовке временный токен
// В ответ приходят постоянные токены
export const confirmPhoneByCode = async (token, data) => {
  const response = await ax.post('/auth/confirm-phone', data, {
    headers: { token }
  });
  return response.data;
};

//Авторизация по рефреш-токену
export const signInByRT = async refresh_token => {
  const response = await ax.post('/auth/refresh', {
    refresh_token,
  });
  return response;
};

//Получение данных пользователя
export const getUserData = async token => {
  const response = await ax.get('/auth', {
    headers: { token }
  });
  return response.data;
};

//ОПРОСЫ

//Загрузка списка опросов
//Пагинация:
//limit - количество элементов на одну страницу пагинации
//page - активная страница

export const getPollsList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/polls?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Просмотр одного опроса
export const getPollInfo = async (token, pollId) => {
  const response = await ax.get('/polls/' + pollId, {
    headers: { token }
  });
  return response.data;
};

//Редактирование опроса
export const editPoll = async (token, data, id) => {
  const response = await ax.put('/polls/' + id, data, {
    headers: { token }
  });
  return response.data;
};

//Изменение видимости опроса (один запрос на скрытие и открытие)
export const changePollVisibility = async (token, data, id) => {
  const response = await ax.patch('/polls/' + id, data, {
    headers: { token }
  });
  return response.data;
};

//Создание опроса
export const createPoll = async (token, data) => {
  const response = await ax.post('/polls', data, {
    headers: { token }
  });
  return response.data;
};

//КЛИЕНТЫ

//Загрузка списка клиентов
//Пагинация:
//limit - количество элементов на одну страницу пагинации
//page - активная страница

export const getClientsList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/customers?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//КОНСУЛЬТАНТЫ

//Загрузка списка консультантов
export const getConsultantsList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/consultants?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Просмотр одного консультанта
export const getConsultantInfo = async (token, id) => {
  const response = await ax.get('/consultants/' + id, {
    headers: { token }
  });
  return response.data;
};

//ШАБЛОНЫ ВИЗИТОК
//Загрузка списка шаблонов
//Пагинация:
//limit - количество элементов на одну страницу пагинации
//page - активная страница

export const getTemplatesList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/cardstemplates?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Просмотр одного шаблона визитки
export const getTemplateInfo = async (token, templateId) => {
  const response = await ax.get('/cardstemplates/' + templateId, {
    headers: { token }
  });
  return response.data;
};

//Изменение видимости шаблона визитки (один запрос на скрытие и открытие)
export const changeTemplateVisibility = async (token, data, templateId) => {
  const response = await ax.patch('/cardstemplates/' + templateId, data, {
    headers: { token }
  });
  return response.data;
};

//Удаление шаблона
export const deleteTemplate = async (token, templateId) => {
  try {
    await ax({
      method: 'delete',
      url: '/cardstemplates/' + templateId,
      headers: { token }
    });
  } catch {
    throw new Error('Невозможно удалить шаблон!');
  }
};

//Редактирование шаблона
export const editTemplate = async (token, data, templateId) => {
  const response = await ax.put('/cardstemplates/' + templateId, data, {
    headers: { token }
  });
  return response.data;
};

//Создание шаблона
export const createTemplate = async (token, data) => {
  const response = await ax.post('/cardstemplates', data, {
    headers: { token }
  });
  return response.data;
};

//ЗАГРУЗКА ФАЙЛОВ НА СЕРВЕР
export const uploadImage = async (token, file) => {
  let response;
  const bodyFormData = new FormData();
  bodyFormData.append('image', file);
  try {
    response = await ax({
      method: "post",
      url: '/files/upload',
      data: bodyFormData,
      headers: {
        'Content-Type': 'multipart/form-data',
        token,
      }
    });
  } catch {
    throw new Error("Не удалось сохранить файл");
  }
  return response.data;
};

//АНАЛИТИКА

//Загрузка с сервера массивов доступных фильтров
export const getFilterData = async token => {
  const response = await ax.get('/exports/filterdata', {
    headers: { token }
  });
  return response.data;
};

//ПЯТЬ МЕТОДОВ для одной и той же action, формирующие файл отчета
//Разница будет в содержимом самого файла

//Кол-во Консультантов и Клиентов - registrations
export const getRegistrationsReport = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/exports/registrations?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Кол-во Клиентов у Консультанта - consultantsclients
export const getConsultantsClientsReport = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/exports/consultantsclients?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Информация по Клиентам - clients
export const getClientsReport = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/exports/clients?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Кол-во Клиентов по статусам - clientsonline
export const getClientsOnlineReport = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/exports/clientsonline?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Информация по Ленте - feedstat
export const getFeedstatReport = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/exports/feedstat?' + queryString, {
    headers: { token }
  });
  return response.data;
};


//СООБЩЕНИЯ

//Загрузка списка сообщений
//Пагинация:
//limit - количество элементов на одну страницу пагинации
//page - активная страница

export const getMessagesList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/support/messages?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Просмотр одного сообщения
export const getMessageInfo = async (token, msgId) => {
  const response = await ax.get('/support/messages/' + msgId, {
    headers: { token }
  });
  return response.data;
};

//Редактирование сообщения
export const editMessage = async (token, data, msgId) => {
  const response = await ax.put('/support/put_messages/' + msgId, data, {
    headers: { token }
  });
  return response.data;
};

//Создание сообщения
export const createMessage = async (token, data) => {
  const response = await ax.post('/support/create_messages', data, {
    headers: { token }
  });
  return response.data;
};

//Удаление сообщения
export const deleteMessage = async (token, msgId) => {
  try {
    await ax({
      method: 'delete',
      url: '/support/messages/' + msgId,
      headers: { token }
    });
  } catch {
    throw new Error('Невозможно удалить сообщение!');
  }
};

//ВОПРОСЫ ПОДДЕРЖКИ
//Загрузка списка вопросов
//Пагинация:
//limit - количество элементов на одну страницу пагинации
//page - активная страница

export const getQuestionsList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/support/menu?' + queryString, {
    headers: { token }
  });
  return response.data;
};

//Изменение видимости вопроса (один запрос на скрытие и открытие)
export const changeQuestionVisibility = async (token, data, questionId) => {
  const response = await ax.patch('/support/menu/' + questionId, data, {
    headers: { token }
  });
  return response.data;
};

//Просмотр одного вопроса
export const getQuestionInfo = async (token, questionId) => {
  const response = await ax.get('/support/menu/' + questionId, {
    headers: { token }
  });
  return response.data;
};

//Удаление вопроса
export const deleteQuestion = async (token, questionId) => {
  try {
    await ax({
      method: 'delete',
      url: '/support/menu/' + questionId,
      headers: { token }
    });
  } catch {
    throw new Error('Невозможно удалить вопрос!');
  }
};

//Редактирование вопроса
export const editQuestion = async (token, data, questionId) => {
  const response = await ax.put('/support/menu/' + questionId, data, {
    headers: { token }
  });
  return response.data;
};

//Создание вопроса
export const createQuestion = async (token, data) => {
  const response = await ax.post('/support/menu', data, {
    headers: { token }
  });
  return response.data;
};

//Изменение порядка вопросов в массиве
export const sortQuestions = async (token, data) => {
  await ax.patch('/support/menu', data, {
    headers: { token }
  });
};

//Получение количества видимых родительских вопросов для клиентов и консультантов
export const getQuestionsCount = async token => {
  const response = await ax.get('/support/menu/count', {
    headers: { token }
  });
  return response.data;
};

// разблокировка телефонов
export const checkBlockedPhone = async (token, data) => {
  const response = await ax.get('/phone/blocked/' + data , {
    headers: { token }
  });
  return response.data;
};
export const checkVerificationPhone = async (token, data) => {
  const response = await ax.get('/phone/verification/' + data , {
    headers: { token }
  });
  return response.data;
};

export const unblockPhone = async (token, data) => {
  const response = await ax.post('/phone/unblock', {phone: data}, {
    headers: { token }
  });
  return response.data;
}

//ЛОКАЛИЗАЦИИ

//Загрузка списка локализаций
export const getLocalizationsList = async (token, payload) => {
  const queryString = qs.stringify(payload, {indices: false});
  const response = await ax.get('/localizations?' + queryString, {
    headers: { token },
    baseURL: domain + '/api/v13/site'
  });
  return response.data;
};

//Изменение значения локализации
export const changeLocalizationById = async (token, payload) => {
  const response = await ax.put('/localizations/', payload, {
    headers: { token },
    baseURL: domain + '/api/v13/site'
  });
  return response.data;
};
